// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_42942e9","title":"_7003207"};